import React from 'react';

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="app-logo">
    <div className="h-8 w-8 shrink-0 rounded-[8px] bg-[hsl(var(--brand-red))] grid place-items-center shadow-[0_4px_14px_rgba(255,0,0,0.35)]">
      <span className="font-display text-[17px] font-bold leading-none text-white">S</span>
    </div>
    {!compact && (
      <div className="leading-tight">
        <div className="font-display text-[15px] font-semibold tracking-tight text-white">
          Spunkram <span className="text-[hsl(var(--text-muted))]">Thumbnailer</span>
        </div>
      </div>
    )}
  </div>
);
